// import { useNavigate } from "react-router-dom";

const DataSubmittedPopup = ({ message, setConfirmationPopup, updateTable }) => {
//   const navigate = useNavigate();

  const handleOkButtonClick = () => {
    setConfirmationPopup(false);
    updateTable()
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg h-40 flex flex-col items-center justify-center">
        <p className="text-sm font-semibold mb-4 text-form-label-pms">
          {message}
        </p>
        <div className="flex gap-4 mt-2">
          <button
            onClick={handleOkButtonClick}
            className="bg-green-500 hover:bg-green-600 text-white rounded-md text-sm w-16 py-2"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default DataSubmittedPopup;
